// extracted by mini-css-extract-plugin
module.exports = {"header":"AuthMenu_header__3g2ox","item":"AuthMenu_item__2gt8w","extension":"AuthMenu_extension__x6XUo","chevron":"AuthMenu_chevron__32Mhi"};